import React from "react";
import { useTranslation } from "react-i18next";
import { T } from "../theme";
import GUIDE_REVIEW from "../data/guideReview.json";

/**
 * "Last reviewed {date}" line for the ABA guide pages.
 *
 * The review metadata lives in src/data/guideReview.json and is stamped by a
 * human reviewer (BCBA/BCaBA) after they verify a page's regulatory claims
 * against current BACB materials. Until a page is stamped (reviewedOn === null)
 * this renders nothing — we never imply a clinical review that hasn't happened.
 * The prebuild freshness check (scripts/check-guide-freshness.js) warns when a
 * page has not been reviewed within the last 6 months.
 */
export default function GuideReviewStamp({ slug }) {
  const { t, i18n } = useTranslation();
  const rec = GUIDE_REVIEW[slug];
  if (!rec || !rec.reviewedOn) return null;

  const parsed = new Date(`${rec.reviewedOn}T00:00:00`);
  const date = Number.isNaN(parsed.getTime())
    ? rec.reviewedOn
    : parsed.toLocaleDateString(i18n.language === "es" ? "es-US" : "en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
  const by = rec.reviewedBy ? ` · ${rec.reviewedBy}` : "";

  return (
    <p
      style={{
        fontSize: 12.5,
        color: T.textLight,
        textAlign: "center",
        margin: "22px 0 0",
      }}
    >
      {t("guideMeta.lastReviewed", { date })}
      {by}
    </p>
  );
}
